import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import "../../styles/Contact.css";
import MainHeader from "../main/MainHeader";
import Footer from "../main/Footer";
import conv from "../../assets/lang/i18n";
import { useCookies } from "react-cookie";
// import Popup from "./Popup";

const ContactPage = () => {
  // const [popup, setPopup] = useState({
  //   open: false,
  //   title: "",
  //   message: "",
  //   callback: false,
  // });

  const [currentLang, setCurrentLang] = useState(conv.language);
  const onLanguageChange = (e) => {
    const langText = e.target.innerText;
    const newLang = langText.includes("English") ? "en" : "ko";
    conv.changeLanguage(newLang);
    setCurrentLang(newLang);

    return currentLang;
  };

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  // const [isSend, setIsSend] = useState(false);
  const [isSave, setIsSave] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies(["savedEmail"]);
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    const saved = cookies.savedEmail;
    if (saved) {
      setEmail(saved);
      setIsSave(true);
    }
  }, [cookies.savedEmail]); // 초기 한 번만 실행

  const handleRememberEmail = (e) => {
    setIsSave(e.target.checked);
  };

  // const encode = (data) =>
  //   Object.keys(data)
  //     .map(
  //       (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
  //     )
  //     .join("&");

  const handleSubmit = (event) => {
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      return;
    }

    // 쿠키 저장/삭제
    if (isSave) {
      setCookie("savedEmail", email, { maxAge: 2000 });
    } else {
      removeCookie("savedEmail");
    }

    // setIsSend(true);

    // Netlify form submit
    // fetch("/", {
    //   method: "POST",
    //   headers: { "Content-Type": "application/x-www-form-urlencoded" },
    //   body: encode({
    //     "form-name": "contact",
    //     email,
    //     message: content,
    //   }),
    // })
    //   .then(() => {
    //     setPopup({
    //       open: true,
    //       title: conv.t("contact.popup_title"),
    //       message: conv.t("contact.popup_msg"),
    //       callback: function () {
    //         window.location.reload();
    //       },
    //     });
    //   })
    //   .catch((error) => {
    //     setPopup({
    //       open: true,
    //       title: "Error",
    //       message: "Failed to send message. Please try again later.",
    //       callback: false,
    //     });
    //     setIsSend(false);
    //   });

    setValidated(true);
  };

  return (
    <div>
      <MainHeader paramChangeLanguage={onLanguageChange} />
      <main className="form-ask">
        <Form
          name="contact"
          method="POST"
          action="/success" // Netlify에 성공 페이지로 리디렉션 (선택)
          data-netlify="true"
          netlify-honeypot="bot-field"
          className="needs-validation"
          noValidate
          validated={validated}
          onSubmit={handleSubmit}
        >
          {/* Netlify 필수 hidden 필드 */}
          <input type="hidden" name="form-name" value="contact" />
          <input type="hidden" name="bot-field" />

          <h1 className="h3 mb-3 fw-normal">{conv.t("contact.title")}</h1>

          <Form.Group className="form-floating mb-3">
            <Form.Control
              type="email"
              name="email"
              id="floatingInput"
              placeholder="name@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <input type="hidden" name="email" value={email}/>
            <Form.Label htmlFor="floatingInput">
              {conv.t("contact.lb_email")}
            </Form.Label>
            <Form.Control.Feedback type="invalid">
              {conv.t("contact.fb_email")}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="form-floating mb-3">
            <Form.Control
              as="textarea"
              name="message"
              id="ta_content"
              placeholder={conv.t("contact.lb_content")}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
              style={{ height: "150px" }}
            />
            <input type="hidden" name="message" value={message}/>
            <Form.Label htmlFor="ta_content">
              {conv.t("contact.lb_content")}
            </Form.Label>
            <Form.Control.Feedback type="invalid">
              {conv.t("contact.fb_content")}
            </Form.Control.Feedback>
          </Form.Group>

          <div className="checkbox mb-3">
            <label>
              <input
                type="checkbox"
                onChange={handleRememberEmail}
                checked={isSave}
              />
              &nbsp;{conv.t("contact.cb_email")}
            </label>
          </div>

          <button className="w-100 btn btn-lg btn-primary" type="submit">
            {conv.t("contact.btn_send")}
          </button>
        </Form>
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
